import React from 'react';
import $ from 'jquery';
import DriverModal from '../modal/DriverModal'
import { db } from '../firebase';
import { MyContext } from '../context';
import { functions } from '../firebase';
import { Content, BadgeMenu, Pagenation } from '../components';
export default class Driver extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: 0,
      decline: 0,
      target: null,
      search: "",
      page: { start: 0, end: 10, interval: 10 }
    }
  }
  componentDidMount() {
    let _this = this;
    $(document).click(function (event) {
      if (_this.state.target && _this.state.target !== event.target) {
        $(".dropdown-menu").hide();
        _this.setState({ target: null })
      }
    });
  }
  showPopup(e) {
    let target = e.target
    var c = $(target).parent().find(".dropdown-menu");
    $(".dropdown-menu").hide();
    $(c[0]).show();
    this.setState({ target: target });
  }
  showModal(modal, driver, key) {
    modal.current.showModal();
    modal.current.setState({
      show: true,
      driver,
      key
    });
    this.setState({
      key
    })
  }
  updateDriver(status, key) {
    db.updateDriver(key, status);
  }
  updateDriverStatus(id, document, field, option) {
    db.updateDriverById(id, document, field, option);
    let { driver, decline } = this.state;
    driver[document][field] = option;
    let data = null;
    if (driver.licenseInfo.approved && driver.vehicleInfo.approved && driver.documentInfo.registration && driver.documentInfo.insurance) {
      db.updateDriver(id, true);
      data = {
        token: driver.FCMtoken,
        title: "Document verification Approved",
        body: "Welcome to Uffride, your document has been verified. You can now drive for Uffride and earn."
      }
    } else {
      db.updateDriver(id, false);
    }
    if (!option && decline == 0) {
      data = {
        token: driver.FCMtoken,
        title: "Document verification decline",
        body: "Upload Valid Document Certificate",
        data: {
          url: `drivers/${id}/${document}/${field}`
        }
      }
      decline++;
    }
    if (data) {
      functions.sendNotification(data)
        .then(result => {
          console.log(result);
        })
        .catch(error => {
          console.log(error);
        });
    }
    this.setState({
      driver, decline
    })
  }
  editDriver(obj, key) {
  }
  filter(filter) {
    let { page } = this.state;
    page.start = 0;
    page.end = 10;
    this.setState({
      filter, page
    })
  }
  render() {
    return <Content state={this} title="Drivers" />
  }
  subMenu() {
    return (
      <React.Fragment>
        <li className="m-nav__item">
          <a className="btn m-nav__link" onClick={e => {
            this.setState({
              filter: 0
            })
          }}>
            <span className="m-nav__link-text">Drivers</span>
          </a>
        </li>
        {
          this.state.filter == null &&
          <React.Fragment>
            <li className="m-nav__separator">- </li>
            <li className="m-nav__item">
              <a className="btn m-nav__link">
                <span className="m-nav__link-text">{this.state.driver.fullName}</span>
              </a>
            </li>
            <li className="m-nav__separator">- </li>
            <li className="m-nav__item">
              <a className="btn m-nav__link">
                <span className="m-nav__link-text">{this.state.driver.phoneNumber}</span>
              </a>
            </li>
          </React.Fragment>
        }
      </React.Fragment>
    )
  }
  content() {
    return (
      <MyContext.Consumer>
        {state => {
          return (
            <React.Fragment>
              {
                this.state.filter != null &&
                <table id="example" className="table table-striped table-bordered" style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th>S.N.</th>
                      <th>Driver Name</th>
                      <th>Email</th>
                      <th>Signup Date</th>
                      <th>Mobile</th>
                      <th>Documents</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      this.filterDriver(state)
                    }
                  </tbody>
                </table>
              }
              {
                this.state.filter == null && this.document()
              }
              <DriverModal show={this.state.detailModal} id="driverDetailModel" title="Deriver Details" footer={
                <div className="modal-footer" style={{ padding: 0 }}>
                  {/* <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button> */}
                  <button type="button" className="btn btn-primary">Edit Driver</button>
                </div>
              }
                driver={this.state.driver}
                hide={() => {
                  this.setState({
                    detailModal: false,
                    driver: null,
                    decline: 0
                  })
                }} />
              <DriverModal show={this.state.deleteModal} id="driverDeleteModel" title="Delete Deriver Details" footer={
                <div className="modal-footer" style={{ padding: 0 }}>
                  <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={e => { this.delete(this.state.driver.key) }}>Delete Driver</button>
                  <button type="button" className="btn btn-primary" onClick={e => { this.delete(false) }}>Cancel</button>
                </div>
              }
                driver={this.state.driver}
                hide={() => {
                  this.setState({
                    deleteModal: false,
                    driver: null,
                    decline: 0
                  })
                }} />
            </React.Fragment>
          )
        }}
      </MyContext.Consumer>
    )
  }
  leftMenu() {
    return (
      <MyContext.Consumer>
        {state => {
          return (
            <React.Fragment>
              <BadgeMenu className="m-badge m-badge--info" onClick={(e) => { this.filter(0) }} title="All Drivers" value={state.totalDriver} />
              <BadgeMenu className="m-badge m-badge--success" onClick={(e) => { this.filter(1) }} title="Verified Drivers" value={state.totalDriver - state.notVerified} />
              <BadgeMenu className="m-badge m-badge--danger" onClick={(e) => { this.filter(2) }} title="Pending Drivers" value={state.notVerified} />
              <BadgeMenu className="m-badge m-badge--info" onClick={(e) => { this.filter(3) }} title="Online Drivers" value={state.activeDriver} />
            </React.Fragment>
          )
        }}
      </MyContext.Consumer>
    )
  }
  delete(key) {
    if (key) { db.deleteDriver(key); }
    this.setState({
      deleteModal: false,
      driver: null
    })
  }
  filterDriver(state) {
    let drivers;
    switch (this.state.filter) {
      case 1:
        drivers = state.verifiedDrivers;
        break;
      case 2:
        drivers = state.notVerifiedDrivers;
        break;
      case 3:
        drivers = state.activeDriverList;
        break;
      default:
        drivers = state.drivers;
        break;
    }
    let { page } = this.state;
    let sn = page.start + 1;
    return drivers
      .filter(item => {
        return this.props.search.trim() == "" || item.fullName.toLowerCase().includes(this.props.search.toLowerCase().trim())
      }).slice(page.start, page.end)
      .map((item) => {
        return this.comp(item, sn++);
      })
  }
  comp(driver, sn) {
    var strDate = "";
    if (driver.joinDate) {
      let date = new Date(driver.joinDate);
      let month = date.getMonth() + 1
      strDate = (date.getDate() >= 10 ? date.getDate() : "0" + date.getDate()) + "/" + (month < 10 ? "0" + month : month) + "/" + date.getFullYear();
    }
    let fun = (e) => {
      this.setState({
        detailModal: true,
        driver: driver
      })
    };
    return (
      <tr key={driver.key}>
        <td onClick={fun}><a className="btn">{sn}</a></td>
        <td onClick={fun}><a className="btn">{driver.fullName}</a></td>
        <td onClick={fun}><a className="btn">{driver.email}</a></td>
        <td onClick={fun}><a className="btn">{strDate}</a></td>
        <td onClick={fun}><a className="btn">{driver.phoneNumber}</a></td>
        <td>
          <a className="btn" data-toggle="tooltip" data-placement="top" title={driver.verified ? "Documents Verified" : "Documents Not Verified"}
            onClick={e => {
              this.setState({
                driver,
                filter: null,
                decline: 0
              })
            }}
          ><i className="fa fa-file-pdf-o" style={driver.verified ? { color: "green" } : { color: "red" }}></i></a></td>
        <td>
          <div className="btn-group align-items-center">
            {/* <div className="dropdown" >
              <button type="button" className="btn dropdown-toggle" onClick={this.showPopup.bind(this)} data-toggle="dropdown">
              </button>
              <div className="dropdown-menu">
                <a className="dropdown-item btn" onClick={(e) => { this.updateDriver(true, driver.key) }}>
                  <i className="fa fa-check-circle text-success"></i> Active</a>
                <a className="dropdown-item btn" onClick={(e) => { this.updateDriver(false, driver.key) }}>
                  <i className="fa fa-times-circle text-danger"></i> Inactive</a>
              </div>
            </div> */}
            {/* <a className="text-muted btn" title="Send Notification" onClick={(e) => {
              // let data = {
              //   token: driver.FCMtoken,
              //   title: "Test Notification",
              //   body: "This is test notification"
              // }
              // functions.sendNotification(data)
              //   .then(result => {
              //     console.log(result);
              //   })
              //   .catch(error => {
              //     console.log(error);
              //   });
            }}>
              <i className="la la-bell"></i>
            </a> */}
            {/* <a className="text-muted btn" onClick={(e) => {
              this.setState({
                detailModal: true,
                driver: driver
              })
            }}>
              <i className="la la-pencil-square-o"></i>
            </a> */}
            <a className="text-danger btn" onClick={(e) => {
              this.setState({
                deleteModal: true,
                driver: driver
              })
            }}>
              <i className="la la-trash-o"></i>
            </a>
          </div>
        </td>
      </tr>
    )
  }
  document() {
    return <div className="row">
      {this.card("Driving License", "licenseInfo", "imageUrl", "approved")}
      {this.card("Insurance", "documentInfo", "insuranceImageUrl", "insurance")}
      {this.card("Vehicle Registration", "documentInfo", "registrationImageUrl", "registration")}
      {this.card("Vehicle Photo", "vehicleInfo", "imageUrl", "approved")}
    </div>
  }
  card(title, doc, image, status) {
    return <div className="col-lg-3">
      <div className="card">
        <div className="card_header">
          <h2>{title}</h2>
        </div>
        <div className="card_body">
          <div className="image">
            {this.state.driver[doc] && <a href={this.state.driver[doc][image]} target="_blank">
              <img src={this.state.driver[doc][image]} alt="" /></a>}
          </div>
        </div>
        <div className="card_footer">
          {this.state.driver[doc] && !this.state.driver[doc][status] && <button className="btn btn-primary btn-block" onClick={e => {
            this.updateDriverStatus(this.state.driver.key, doc, status, true);
          }}>Approve</button>}
          <button className="btn btn-danger btn-block" onClick={e => {
            this.updateDriverStatus(this.state.driver.key, doc, status, false);
          }}>Decline </button>
        </div>
      </div>
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/include/Driver.js